import { v4 as uuidv4 } from 'uuid';

export default [
    {
        idSoft: uuidv4(),
        name: 'GLOSSY',
        text: 'Brillant',
        value: "Brillant",
    },
    {
        idSoft: uuidv4(),
        name: 'MAT',
        text: 'Matte',
        value: "Matte",
    },
]